export default __webpack_public_path__ + "static/6_30-3af2840e930614a65f96a7336fb34bee.png";